import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import React, { useState } from "react";
import { connect } from "react-redux";
import Confirm from "../../../componentes/Confirm";
import ColumnCrudTableType, { TableMeta } from "../../../componentes/CRUD/columnCrudTableType";
import TableCrud from "../../../componentes/CRUD/table";
import Loading from "../../../componentes/Loading/Loading";
import SnackMessage from "../../../componentes/SnakBar";
import {
  DeleteEstabelecimentoOperadoraProps,
  ListarEstabelecimentosComponent,
  ListarEstabelecimentosDocument,
  withDeleteEstabelecimentoOperadora,
} from "../../../graphql/components";
import { IState } from "../../../redux/reducers";
import EditEstabelecimento from "./editEstabelecimento";

interface PropsEdit {
  conciOperadora: {
    codexterno: string;
  };
  conciliadores: {
    apelido: string;
    codpessoa: number;
  };
  display: string;
  pessoa: {
    pessoa: {
      codpessoa: number;
    };
  };
}

const convertResultToTable = (values: Array<any>) => {
  const result: Array<Array<any>> = [];

  values.forEach((v) => {
    const value: Array<any> = [];
    value.push(v.pessoa.pessoaJ.cnpj);
    value.push(v.pessoa.pessoa.nome);
    value.push(v.conciliadores.apelido);
    value.push(v.conciOperadora.codexterno);
    value.push(v);
    result.push(value);
  });
  return result;
};

interface Props {
  codOperadora?: number | null;
  nomeOperadora?: string;
}

const ListaEstabelecimentos = ({ codOperadora, mutate, nomeOperadora }: DeleteEstabelecimentoOperadoraProps<Props>) => {
  const [deleting, setDeleting] = useState(false);
  const [deletedIndex, setDeletedIndex] = useState<number | null>(null);
  const [message, setMessage] = useState("");
  const [variantSnack, setVariantSnack] = useState<"success" | "warning" | "error" | "info">("success");
  const [editOpen, setEditOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [apelidoLoja, setApelidoLoja] = useState("");
  const [codEstabelecimento, setCodEstabelecimento] = useState<string | null>(null);
  const [codPessoa, setCodPessoa] = useState<number | null>(null);
  const [openSnackMessage, setOpenSnackMessage] = useState(false);
  const closeConfirm = React.useCallback(() => setConfirmOpen(false), []);
  const openConfirm = React.useCallback(() => setConfirmOpen(true), []);
  const deleteRecord = React.useCallback(async () => {
    setDeleting(true);
    await mutate!({
      variables: {
        values: {
          codEstabelecimento: codEstabelecimento ? codEstabelecimento.toString() : undefined,
          codPessoa: codPessoa ? codPessoa.toString() : undefined,
          codoperadora: codOperadora ? codOperadora.toString() : undefined,
        },
      },
      update: (store) => {
        const oldResult: any = store.readQuery({
          query: ListarEstabelecimentosDocument,
          variables: { values: { codoperadora: codOperadora! } },
        });
        if (oldResult) {
          oldResult.listarEstabelecimentos.splice(deletedIndex!, 1);
          store.writeQuery({
            query: ListarEstabelecimentosDocument,
            data: oldResult,
            variables: { values: { codoperadora: codOperadora! } },
          });
        }
      },
    });
    setDeleting(false);
    setMessage("Registro excluído com sucesso!");
    setVariantSnack("success");
    setOpenSnackMessage(true);
    setConfirmOpen(false);
  }, [codEstabelecimento, codOperadora, codPessoa, deletedIndex, mutate]);

  const closeSnackMessage = React.useCallback(() => setOpenSnackMessage(false), []);

  const openEdit = React.useCallback((apelidoLoja: string, codEstabelecimento: string, codPessoa: number, index: number) => {
    setEditOpen(true);
    setApelidoLoja(apelidoLoja);
    setCodEstabelecimento(codEstabelecimento);
    setCodPessoa(codPessoa);
    setDeletedIndex(index);
  }, []);
  const closeEdit = React.useCallback(() => setEditOpen(false), []);
  const colunas: Array<ColumnCrudTableType> = [
    {
      name: "CNPJ",
      options: {
        filter: true,
      },
    },
    {
      name: "Nome",
      options: {
        filter: true,
      },
    },
    {
      name: "Apelido da loja",
      options: {
        filter: true,
      },
    },
    {
      name: "Estabelecimento",
      options: {
        filter: true,
      },
    },
    {
      name: "Ação",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: PropsEdit, tableMeta: TableMeta) => {
          const display = value.display.indexOf("none") > -1 ? "none" : "block";
          return (
            <>
            <div style={{display}}>
              <Tooltip title="Editar" placement="top">
                <IconButton
                  disabled={value.conciOperadora.codexterno !== null}
                  aria-label="Editar"
                  onClick={() =>
                    openEdit(
                      value.conciliadores.apelido,
                      value.conciOperadora.codexterno,
                      value.pessoa.pessoa.codpessoa,
                      tableMeta.rowIndex
                    )
                  }
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            <Tooltip title="Deletar" placement="top">
              <IconButton
                disabled={value.conciOperadora.codexterno !== null}
                aria-label="Excluir"
                onClick={openConfirm}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
          </>
          );
        },
      },
    },
  ];

  if (!codOperadora) {
    return null;
  }
  return (
    <ListarEstabelecimentosComponent variables={{ values: { codoperadora: codOperadora! } }}>
      {({ data, loading }) => {
        if (loading) return <Loading />;
        const result = convertResultToTable(data!.listarEstabelecimentos);
        return (
          <React.Fragment>
            <TableCrud
              columns={colunas}
              titulo=""
              data={result}
              options={{
                selectableRows: "none",
                download: false,
                print: false,
                viewColumns: false,
                filter: false,
                searchable: false,
              }}
            />
            {editOpen && (
              <EditEstabelecimento
                close={closeEdit}
                isOpen={editOpen}
                apelidoLoja={apelidoLoja}
                codEstabelecimento={codEstabelecimento}
                codPessoa={codPessoa}
                index={deletedIndex}
                codOperadora={codOperadora}
                nomeOperadora={nomeOperadora!}
              />
            )}
            <Confirm
              msg="Deseja realmente excluir esse registro?"
              titulo="Atenção"
              open={confirmOpen}
              close={closeConfirm}
              okCallback={deleteRecord}
              disabled={deleting}
            />
            {message.length > 0 && (
              <SnackMessage open={openSnackMessage} close={closeSnackMessage} variant={variantSnack} message={message} />
            )}
          </React.Fragment>
        );
      }}
    </ListarEstabelecimentosComponent>
  );
};

const mapStateToProps = (state: IState) => ({
  ...state,
  codOperadora: state.painelCadastroReducer.codOperadora,
  nomeOperadora: state.painelCadastroReducer.nomeOperadora,
});

const withDelete = withDeleteEstabelecimentoOperadora<Props>({});

const withMutation = withDelete(ListaEstabelecimentos);

const EditEstabelecimentoMapped = connect(
  mapStateToProps,
  null
)(React.memo(withMutation));

export default React.memo(EditEstabelecimentoMapped);
